import * as React from 'react';
import { IconFinanceArrowBoldDown16, IconFinanceArrowBoldUp16 } from '@cian/ui-kit-design-tokens/icons';

import { TPriceDiff } from '../../../types/realtyValuation';

interface IPriceDiffProps {
  diff: TPriceDiff;
}

export const PriceDiff: React.FC<IPriceDiffProps> = ({ diff }) => {
  return diff === 'increase' ? (
    <IconFinanceArrowBoldUp16 display="block" color="icon-negative-default" />
  ) : (
    <IconFinanceArrowBoldDown16 display="block" color="icon-positive-default" />
  );
};
